import './../../stylesheets/hold_periods';

import * as randomNumberComponent from './random_number';

// 追加ボタン
export function addHoldPeriodButton () {
  let button = document.getElementById('add_hold_period');
  if (!!button) {
    button.addEventListener('click', function(event) {
      // 連打防止
      button.disabled = true;
      // 乱数を生成
      let randomNumber = createRandomNumber();
      // source_typeを取得
      let sorceType = button.dataset['sourceType'];
      // 追加する箇所を取得
      let target = this.closest('.row').querySelector('div.holdPeriod');
      if (!!target) {
        target = target.parentElement;
      } else {
        target = this.closest('.row').querySelector('div.col-12:last-child');
      }
      // 現在の時刻を取得
      let currentDate = new Date();
      // 年
      let currentYear = currentDate.getFullYear();
      let minYear = currentYear - 100;
      // 月
      let currentMonth = currentDate.getMonth() + 1;
      // 日
      let currentDay = currentDate.getDate();
      // 時
      let currentHours = currentDate.getHours();

      // 追加するrowを生成
      let row = document.createElement('div');
      row.classList.add('row', 'holdPeriod');

      // 開催区分
      let colHoldPeriodType = document.createElement('div');
      colHoldPeriodType.classList.add('col-12');
      let colHoldPeriodFormGroup = document.createElement('div');
      colHoldPeriodFormGroup.classList.add('holdPeriodType', 'form-group');
      colHoldPeriodType.appendChild(colHoldPeriodFormGroup);
      row.appendChild(colHoldPeriodType);

      // 開催区分の選択肢（１日開催）
      let colHoldPeriodCustomOneDay = document.createElement('div');
      colHoldPeriodCustomOneDay.classList.add('custom-control', 'custom-control-inline', 'custom-radio');
      let colHoldPeriodCustomInputOneDay = document.createElement('input');
      colHoldPeriodCustomInputOneDay.id = sorceType + '_hold_periods_attributes_' + randomNumber + '_period_type_one_day';
      colHoldPeriodCustomInputOneDay.classList.add('custom-control-input');
      colHoldPeriodCustomInputOneDay.type = 'radio';
      colHoldPeriodCustomInputOneDay.value = 'one_day';
      colHoldPeriodCustomInputOneDay.name = sorceType + '[hold_periods_attributes][' + randomNumber + '][period_type]';
      colHoldPeriodCustomInputOneDay.checked = true;
      colHoldPeriodCustomInputOneDay.addEventListener('change', function(event) {
        changeDisabledHoldPeriodType(this);
      });
      colHoldPeriodCustomOneDay.appendChild(colHoldPeriodCustomInputOneDay);
      let colHoldPeriodCustomLabelOneDay = document.createElement('label');
      colHoldPeriodCustomLabelOneDay.classList.add('custom-control-label');
      colHoldPeriodCustomLabelOneDay.htmlFor = colHoldPeriodCustomInputOneDay.id;
      colHoldPeriodCustomLabelOneDay.innerHTML = '１日開催';
      colHoldPeriodCustomOneDay.appendChild(colHoldPeriodCustomLabelOneDay);
      // 開催区分 < 開催区分の選択肢（１日開催）
      colHoldPeriodFormGroup.appendChild(colHoldPeriodCustomOneDay);

      // 開催区分の選択肢（期間開催）
      let colHoldPeriodCustomPeriod = document.createElement('div');
      colHoldPeriodCustomPeriod.classList.add('custom-control', 'custom-control-inline', 'custom-radio');
      let colHoldPeriodCustomInputPeriod = document.createElement('input');
      colHoldPeriodCustomInputPeriod.id = sorceType + '_hold_periods_attributes_' + randomNumber + '_period_type_period';
      colHoldPeriodCustomInputPeriod.classList.add('custom-control-input');
      colHoldPeriodCustomInputPeriod.type = 'radio';
      colHoldPeriodCustomInputPeriod.value = 'period';
      colHoldPeriodCustomInputPeriod.name = sorceType + '[hold_periods_attributes][' + randomNumber + '][period_type]';
      colHoldPeriodCustomInputPeriod.addEventListener('change', function(event) {
        changeDisabledHoldPeriodType(this);
      });
      colHoldPeriodCustomPeriod.appendChild(colHoldPeriodCustomInputPeriod);
      let colHoldPeriodCustomLabelPeriod = document.createElement('label');
      colHoldPeriodCustomLabelPeriod.classList.add('custom-control-label');
      colHoldPeriodCustomLabelPeriod.htmlFor = colHoldPeriodCustomInputPeriod.id;
      colHoldPeriodCustomLabelPeriod.innerHTML = '期間開催';
      colHoldPeriodCustomPeriod.appendChild(colHoldPeriodCustomLabelPeriod);
      // 開催区分 < 開催区分の選択肢（期間開催）
      colHoldPeriodFormGroup.appendChild(colHoldPeriodCustomPeriod);

      // 開催区分の選択肢（随時）
      if (sorceType=='volunteer') {
        let colHoldPeriodCustomAnyTime = document.createElement('div');
        colHoldPeriodCustomAnyTime.classList.add('custom-control', 'custom-control-inline', 'custom-radio');
        let colHoldPeriodCustomInputAnyTime = document.createElement('input');
        colHoldPeriodCustomInputAnyTime.id = sorceType + '_hold_periods_attributes_' + randomNumber + '_period_type_any_time';
        colHoldPeriodCustomInputAnyTime.classList.add('custom-control-input');
        colHoldPeriodCustomInputAnyTime.type = 'radio';
        colHoldPeriodCustomInputAnyTime.value = 'any_time';
        colHoldPeriodCustomInputAnyTime.name = sorceType + '[hold_periods_attributes][' + randomNumber + '][period_type]';
        colHoldPeriodCustomInputAnyTime.addEventListener('change', function(event) {
          changeDisabledHoldPeriodType(this);
        });
        colHoldPeriodCustomAnyTime.appendChild(colHoldPeriodCustomInputAnyTime);
        let colHoldPeriodCustomLabelAnyTime = document.createElement('label');
        colHoldPeriodCustomLabelAnyTime.classList.add('custom-control-label');
        colHoldPeriodCustomLabelAnyTime.htmlFor = colHoldPeriodCustomInputAnyTime.id;
        colHoldPeriodCustomLabelAnyTime.innerHTML = '随時開催';
        colHoldPeriodCustomAnyTime.appendChild(colHoldPeriodCustomLabelAnyTime);
        // 開催区分 < 開催区分の選択肢（随時）
        colHoldPeriodFormGroup.appendChild(colHoldPeriodCustomAnyTime);
      }

      // 削除ボタン
      let deleteSpan = document.createElement('span');
      deleteSpan.classList.add('float-right');
      let deleteButton = document.createElement('button');
      deleteButton.name = 'button';
      deleteButton.type = 'button';
      deleteButton.classList.add('btn', 'btn-xs', 'btn-danger', 'delete_hold_period');
      deleteButton.innerHTML = '削除'
      deleteSpan.appendChild(deleteButton);
      // 削除ボタンにイベントを付与
      deleteButton.addEventListener('click', function(event) {
        let message = '開催期間を削除します。\nよろしいですか？';
        if (window.confirm(message)) {
          let holdPeriod = this.closest('div.holdPeriod');
          holdPeriod.remove();
        };
      });
      // 開催区分 < 削除ボタン
      colHoldPeriodFormGroup.appendChild(deleteSpan);

      // 開始日時
      let colHoldPeriodStartAt = document.createElement('div');
      colHoldPeriodStartAt.classList.add('col-12', 'col-md-6');
      let colHoldPeriodStartAtFormGroup = document.createElement('div');
      colHoldPeriodStartAtFormGroup.classList.add('holdPeriodStartAt', 'form-group');
      colHoldPeriodStartAt.appendChild(colHoldPeriodStartAtFormGroup);
      let colHoldPeriodStartAtFormLabel = document.createElement('label');
      colHoldPeriodStartAtFormLabel.classList.add('d-block', 'required');
      colHoldPeriodStartAtFormLabel.htmlFor = sorceType + '_hold_periods_attributes_' + randomNumber + '_start_at';
      colHoldPeriodStartAtFormLabel.innerHTML = '開始日時';
      colHoldPeriodStartAtFormGroup.appendChild(colHoldPeriodStartAtFormLabel);

      // 年セレクト
      let colHoldPeriodStartAtYearSelect = document.createElement('select');
      colHoldPeriodStartAtYearSelect.id = sorceType + '_hold_periods_attributes_' + randomNumber + '_start_at_1i';
      colHoldPeriodStartAtYearSelect.name = sorceType + '[hold_periods_attributes][' + randomNumber + '][start_at(1i)]';
      colHoldPeriodStartAtYearSelect.classList.add('mr-1');
      for (var i = minYear; i <= minYear + 200; i++) {
        var colHoldPeriodStartAtYearOprion = document.createElement('option');
        colHoldPeriodStartAtYearOprion.value = i;
        colHoldPeriodStartAtYearOprion.innerHTML = i;
        if (i == currentYear) {
          colHoldPeriodStartAtYearOprion.selected = true;
        }
        colHoldPeriodStartAtYearSelect.appendChild(colHoldPeriodStartAtYearOprion);
      }
      // selectitemを追加
      colHoldPeriodStartAtFormGroup.appendChild(colHoldPeriodStartAtYearSelect);

      // 月セレクト
      let colHoldPeriodStartAtMonthSelect = document.createElement('select');
      colHoldPeriodStartAtMonthSelect.id = sorceType + '_hold_periods_attributes_' + randomNumber + '_start_at_2i';
      colHoldPeriodStartAtMonthSelect.name = sorceType + '[hold_periods_attributes][' + randomNumber + '][start_at(2i)]';
      colHoldPeriodStartAtMonthSelect.classList.add('mr-1');
      for (var i = 1; i <= 12; i++) {
        var colHoldPeriodStartAtMonthOption = document.createElement('option');
        colHoldPeriodStartAtMonthOption.value = i;
        colHoldPeriodStartAtMonthOption.innerHTML = String(i) + '月';
        if (i == currentMonth) {
          colHoldPeriodStartAtMonthOption.selected = true;
        }
        colHoldPeriodStartAtMonthSelect.appendChild(colHoldPeriodStartAtMonthOption);
      }
      // selectitemを追加
      colHoldPeriodStartAtFormGroup.appendChild(colHoldPeriodStartAtMonthSelect);

      // 日セレクト
      let colHoldPeriodStartAtDaySelect = document.createElement('select');
      colHoldPeriodStartAtDaySelect.id = sorceType + '_hold_periods_attributes_' + randomNumber + '_start_at_3i';
      colHoldPeriodStartAtDaySelect.name = sorceType + '[hold_periods_attributes][' + randomNumber + '][start_at(3i)]';
      for (var i = 1; i <= 31; i++) {
        var colHoldPeriodStartAtDayOption = document.createElement('option');
        colHoldPeriodStartAtDayOption.value = i;
        colHoldPeriodStartAtDayOption.innerHTML = i;
        if (i == currentDay) {
          colHoldPeriodStartAtDayOption.selected = true;
        }
        colHoldPeriodStartAtDaySelect.appendChild(colHoldPeriodStartAtDayOption);
      }
      // selectitemを追加
      colHoldPeriodStartAtFormGroup.appendChild(colHoldPeriodStartAtDaySelect);
      // ハイフン
      var hyphen = document.createTextNode(' — ');
      colHoldPeriodStartAtFormGroup.appendChild(hyphen);

      // 時セレクト
      let colHoldPeriodStartAtHourSelect = document.createElement('select');
      colHoldPeriodStartAtHourSelect.id = sorceType + '_hold_periods_attributes_' + randomNumber + '_start_at_4i';
      colHoldPeriodStartAtHourSelect.name = sorceType + '[hold_periods_attributes][' + randomNumber + '][start_at(4i)]';
      for (var i = 0; i <= 23; i++) {
        var colHoldPeriodStartAtHoursOption = document.createElement('option');
        colHoldPeriodStartAtHoursOption.value = ('00' + i).slice(-2);
        colHoldPeriodStartAtHoursOption.innerHTML = ('00' + i).slice(-2);
        if (i == currentHours) {
          colHoldPeriodStartAtHoursOption.selected = true;
        }
        colHoldPeriodStartAtHourSelect.appendChild(colHoldPeriodStartAtHoursOption);
      }
      // selectitemを追加
      colHoldPeriodStartAtFormGroup.appendChild(colHoldPeriodStartAtHourSelect);
      // コロン
      var colon = document.createTextNode(' : ');
      colHoldPeriodStartAtFormGroup.appendChild(colon);

      // 分セレクト
      let colHoldPeriodStartAtMinuteSelect = document.createElement('select');
      colHoldPeriodStartAtMinuteSelect.id = sorceType + '_hold_periods_attributes_' + randomNumber + '_start_at_5i';
      colHoldPeriodStartAtMinuteSelect.name = sorceType + '[hold_periods_attributes][' + randomNumber + '][start_at(5i)]';
      for (var i = 0; i <= 45; i=i+15) {
        var colHoldPeriodStartAtMinuteOption = document.createElement('option');
        colHoldPeriodStartAtMinuteOption.value = ('00' + i).slice(-2);
        colHoldPeriodStartAtMinuteOption.innerHTML = ('00' + i).slice(-2);
        colHoldPeriodStartAtMinuteSelect.appendChild(colHoldPeriodStartAtMinuteOption);
      }
      // selectitemを追加
      colHoldPeriodStartAtFormGroup.appendChild(colHoldPeriodStartAtMinuteSelect);


      // 終了日時
      let colHoldPeriodEndAt = document.createElement('div');
      colHoldPeriodEndAt.classList.add('col-12', 'col-md-6');
      let colHoldPeriodEndAtFormGroup = document.createElement('div');
      colHoldPeriodEndAtFormGroup.classList.add('holdPeriodEndAt', 'form-group');
      colHoldPeriodEndAt.appendChild(colHoldPeriodEndAtFormGroup);
      let colHoldPeriodEndAtFormLabel = document.createElement('label');
      colHoldPeriodEndAtFormLabel.classList.add('d-block');
      colHoldPeriodEndAtFormLabel.htmlFor = sorceType + '_hold_periods_attributes_' + randomNumber + '_end_at';
      colHoldPeriodEndAtFormLabel.innerHTML = '終了日時';
      colHoldPeriodEndAtFormGroup.appendChild(colHoldPeriodEndAtFormLabel);

      // 年セレクト
      let colHoldPeriodEndAtYearSelect = document.createElement('select');
      colHoldPeriodEndAtYearSelect.id = sorceType + '_hold_periods_attributes_' + randomNumber + '_end_at_1i';
      colHoldPeriodEndAtYearSelect.name = sorceType + '[hold_periods_attributes][' + randomNumber + '][end_at(1i)]';
      colHoldPeriodEndAtYearSelect.classList.add('mr-1');
      colHoldPeriodEndAtYearSelect.disabled = true;
      for (var i = minYear; i <= minYear + 200; i++) {
        var colHoldPeriodEndAtYearOprion = document.createElement('option');
        colHoldPeriodEndAtYearOprion.value = i;
        colHoldPeriodEndAtYearOprion.innerHTML = i;
        if (i == currentYear) {
          colHoldPeriodEndAtYearOprion.selected = true;
        }
        colHoldPeriodEndAtYearSelect.appendChild(colHoldPeriodEndAtYearOprion);
      }
      // selectitemを追加
      colHoldPeriodEndAtFormGroup.appendChild(colHoldPeriodEndAtYearSelect);

      // 月セレクト
      let colHoldPeriodEndAtMonthSelect = document.createElement('select');
      colHoldPeriodEndAtMonthSelect.id = sorceType + '_hold_periods_attributes_' + randomNumber + '_end_at_2i';
      colHoldPeriodEndAtMonthSelect.name = sorceType + '[hold_periods_attributes][' + randomNumber + '][end_at(2i)]';
      colHoldPeriodEndAtMonthSelect.classList.add('mr-1');
      colHoldPeriodEndAtMonthSelect.disabled = true;
      for (var i = 1; i <= 12; i++) {
        var colHoldPeriodEndAtMonthOption = document.createElement('option');
        colHoldPeriodEndAtMonthOption.value = i;
        colHoldPeriodEndAtMonthOption.innerHTML = String(i) + '月';
        if (i == currentMonth) {
          colHoldPeriodEndAtMonthOption.selected = true;
        }
        colHoldPeriodEndAtMonthSelect.appendChild(colHoldPeriodEndAtMonthOption);
      }
      // selectitemを追加
      colHoldPeriodEndAtFormGroup.appendChild(colHoldPeriodEndAtMonthSelect);

      // 日セレクト
      let colHoldPeriodEndAtDaySelect = document.createElement('select');
      colHoldPeriodEndAtDaySelect.id = sorceType + '_hold_periods_attributes_' + randomNumber + '_end_at_3i';
      colHoldPeriodEndAtDaySelect.name = sorceType + '[hold_periods_attributes][' + randomNumber + '][end_at(3i)]';
      colHoldPeriodEndAtDaySelect.disabled = true;
      for (var i = 1; i <= 31; i++) {
        var colHoldPeriodEndAtDayOption = document.createElement('option');
        colHoldPeriodEndAtDayOption.value = i;
        colHoldPeriodEndAtDayOption.innerHTML = i;
        if (i == currentDay) {
          colHoldPeriodEndAtDayOption.selected = true;
        }
        colHoldPeriodEndAtDaySelect.appendChild(colHoldPeriodEndAtDayOption);
      }
      // selectitemを追加
      colHoldPeriodEndAtFormGroup.appendChild(colHoldPeriodEndAtDaySelect);
      // ハイフン
      var hyphen = document.createTextNode(' — ');
      colHoldPeriodEndAtFormGroup.appendChild(hyphen);

      // 時セレクト
      let colHoldPeriodEndAtHourSelect = document.createElement('select');
      colHoldPeriodEndAtHourSelect.id = sorceType + '_hold_periods_attributes_' + randomNumber + '_end_at_4i';
      colHoldPeriodEndAtHourSelect.name = sorceType + '[hold_periods_attributes][' + randomNumber + '][end_at(4i)]';
      colHoldPeriodEndAtHourSelect.disabled = true;
      for (var i = 0; i <= 23; i++) {
        var colHoldPeriodEndAtHoursOption = document.createElement('option');
        colHoldPeriodEndAtHoursOption.value = ('00' + i).slice(-2);
        colHoldPeriodEndAtHoursOption.innerHTML = ('00' + i).slice(-2);
        if (i == currentHours) {
          colHoldPeriodEndAtHoursOption.selected = true;
        }
        colHoldPeriodEndAtHourSelect.appendChild(colHoldPeriodEndAtHoursOption);
      }
      // selectitemを追加
      colHoldPeriodEndAtFormGroup.appendChild(colHoldPeriodEndAtHourSelect);
      // コロン
      var colon = document.createTextNode(' : ');
      colHoldPeriodEndAtFormGroup.appendChild(colon);

      // 分セレクト
      let colHoldPeriodEndAtMinuteSelect = document.createElement('select');
      colHoldPeriodEndAtMinuteSelect.id = sorceType + '_hold_periods_attributes_' + randomNumber + '_end_at_5i';
      colHoldPeriodEndAtMinuteSelect.name = sorceType + '[hold_periods_attributes][' + randomNumber + '][end_at(5i)]';
      colHoldPeriodEndAtMinuteSelect.disabled = true;
      for (var i = 0; i <= 45; i=i+15) {
        var colHoldPeriodEndAtMinuteOption = document.createElement('option');
        colHoldPeriodEndAtMinuteOption.value = ('00' + i).slice(-2);
        colHoldPeriodEndAtMinuteOption.innerHTML = ('00' + i).slice(-2);
        colHoldPeriodEndAtMinuteSelect.appendChild(colHoldPeriodEndAtMinuteOption);
      }
      // selectitemを追加
      colHoldPeriodEndAtFormGroup.appendChild(colHoldPeriodEndAtMinuteSelect);

      // 要素をターゲットに追加
      row.appendChild(colHoldPeriodStartAt);
      row.appendChild(colHoldPeriodEndAt);
      target.appendChild(row);

      // 連打防止
      button.disabled = false;
    })
  }
}

// 開催期間の区分を選択
export function selectHoldPeriodType () {
  let holdPeriodTypes = document.querySelectorAll('div.holdPeriod input[type="radio"]');

  for (var i = 0; i < holdPeriodTypes.length; i++) {
    if (!!holdPeriodTypes[i]) {
      holdPeriodTypes[i].addEventListener('change', function(event) {
        if (this.checked) {
          changeDisabledHoldPeriodType(this);
        }
      });
    }
  }
}

// 削除ボタン
export function deleteHoldPeriodButton () {
  let buttons = document.querySelectorAll('button.delete_hold_period');
  for (let i = 0; i < buttons.length; i++) {
    if (!!buttons[i]) {
      buttons[i].addEventListener('click', function(event) {
        let message = '開催期間を削除します。\nよろしいですか？';
        if (window.confirm(message)) {
          let holdPeriod = this.closest('div.holdPeriod');
          let destroyFlg = holdPeriod.querySelector('input.destroy_flg');
          if (!!destroyFlg) {
            destroyFlg.value = true;
            holdPeriod.classList.add('d-none');
          } else {
            holdPeriod.remove();
          }
        }
      });
    }
  }
}

// ランダムな数値を生成
function createRandomNumber () {
  return randomNumberComponent.createNumberForDateTime();
}

// 開催期間の区分の選択によって開始と終了の入力を制限する
function changeDisabledHoldPeriodType (element) {
  let holdPeriodElement = element.closest('div.holdPeriod');
  if (!!holdPeriodElement) {
    // 開始日時
    let startElement = holdPeriodElement.querySelector('div.holdPeriodStartAt')
    let startSelects = startElement.querySelectorAll('select');
    // 終了日時
    let endElement = holdPeriodElement.querySelector('div.holdPeriodEndAt')
    let endSelects = endElement.querySelectorAll('select');

    if (element.value == 'any_time') {
      // 開始日時入力不可
      changeDisabled(startSelects, true)
      // 終了日時入力不可
      changeDisabled(endSelects, true)
      // 開始日時から必須を削除
      startElement.querySelector('label').classList.remove('required');
      // 終了日時から必須を削除
      endElement.querySelector('label').classList.remove('required');
    } else if (element.value == 'one_day') {
      // 開始日時入力可
      changeDisabled(startSelects, false)
      // 開始日時に必須を追加
      startElement.querySelector('label').classList.add('required');
      // 終了日時入力可
      changeDisabled(endSelects, true)
      // 終了日時に必須を追加
      endElement.querySelector('label').classList.remove('required');
    } else if (element.value == 'period') {
      // 開始日時入力可
      changeDisabled(startSelects, false)
      // 開始日時に必須を追加
      startElement.querySelector('label').classList.add('required');
      // 終了日時入力可
      changeDisabled (endSelects, false)
      // 終了日時に必須を追加
      endElement.querySelector('label').classList.add('required');
    }
  }
}

// elements内の要素全ての表示を変更
function changeDisabled (elements, bool){
  if (!!elements) {
    for (let i = 0; i < elements.length; i++) {
      elements[i].disabled = bool;
    }
  }
}
